<template>
  <div class="customer-journal-table">
    <v-sheet class="pa-4">
      <v-row align="center" v-if="isAdmin">
        <v-col cols="4">
          <v-select
            outlined
            dense
            v-model="selectedLocation"
            :items="locations"
            item-text="attributes.name"
            item-value="attribuate.name"
            label="Filter by Location"
            hide-details
            clearable
            @change="getJournals"
          ></v-select>
        </v-col>
      </v-row>

      <v-row v-if="false">
        <v-col class="text-center location-name" :class="{ 'active': (location.attributes.name === selectedLocation) }" v-for="location in locations" :key="location.id">
          {{ location.attributes.name }}
        </v-col>
      </v-row>

      <v-row v-if="ifShowPassed">
        <v-col class="mt-4 text-center">
          <v-btn text @click="hideAllPassed">Hide All Passed</v-btn>
        </v-col>
      </v-row>

      <v-row v-if="!ifShowPassed">
        <v-col v-for="date in datesArray" :key="date" class="text-center">
          <v-card :color="(date.total === date.completed) ? '#234f25' : '#571d1d'" v-if="now > date.date" @click="selectDate(date.date)" class="py-2">
            <div><strong>{{ DateTime.fromISO(date.date).toFormat('LL/dd') }}</strong></div>
            <div v-if="date.total === date.completed"><v-icon color="success">mdi-check</v-icon></div>
            <div v-if="date.total !== date.completed"><v-icon color="error">mdi-close</v-icon></div>
            <div><small>{{ date.completed }} / {{ date.total }}</small></div>
          </v-card>
          <v-card :color="(selectedDate === date.date) ? '#0c375c' : ''" class="date-select py-2" v-if="now === date.date" @click="selectDate(date.date)">
            <div><strong>{{ DateTime.fromISO(date.date).toFormat('LL/dd') }}</strong></div>
            <div><v-icon></v-icon></div>
            <div><small>{{ date.total }}</small></div>
          </v-card>
          <v-card :color="(selectedDate === date.date) ? '#0c375c' : ''" class="date-select py-2" v-if="now < date.date" @click="selectDate(date.date)">
            <div><strong>{{ DateTime.fromISO(date.date).toFormat('LL/dd') }}</strong></div>
            <div><v-icon>mdi-dots-horizontal</v-icon></div>
            <div><small>{{ date.total }}</small></div>
          </v-card>
        </v-col>
      </v-row>

      <v-simple-table v-if="!ifShowPassed && !isJournalsLoading && journals" class="mt-3">
        <thead>
          <tr>
            <th class="text-left">Time</th>
            <th class="text-left">Class</th>
            <th class="text-left">Customer</th>
            <th class="text-left">Payment Method</th>
            <th class="text-left">Given</th>
            <th class="text-left">Initials</th>
            <th class="text-left">Note</th>
            <th></th>
          </tr>
        </thead>
        <tbody v-if="selectedDateJournals.length > 0">
          <tr v-for="journal in selectedDateJournals" :key="journal.id" :class="rowClass(journal.marianatek_reservation_start_date)">
            <td>{{ formatTime(journal.marianatek_reservation_start_time) }}</td>
            <td>{{ journal.marianatek_reservation_class_name }}</td>
            <td>{{ journal.marianatek_customer_name }}</td>
            <td>{{ journal.payment_method }}</td>
            <td><v-simple-checkbox disabled :value="journal.is_redeemed"></v-simple-checkbox></td>
            <td>{{ journal.initials }}</td>
            <td>{{ journal.note }}</td>
            <td>
              <v-btn v-if="!isComplete(journal)" @click="openEdit(journal)"><v-icon>mdi-pencil</v-icon></v-btn>
              <v-btn v-if="isComplete(journal)" color="success" @click="openEdit(journal)"><v-icon>mdi-check</v-icon></v-btn>
            </td> 
          </tr>
        </tbody>
        <tbody v-if="selectedDateJournals.length === 0">
          <tr>
            <td colspan="8" class="text-center">No journals found for this date.</td>
          </tr>
        </tbody>
      </v-simple-table>

      <v-simple-table v-if="ifShowPassed" class="mt-3">
        <thead>
          <tr>
            <th class="text-left">Time</th>
            <th class="text-left">Class</th>
            <th class="text-left">Customer</th>
            <th class="text-left">Payment Method</th>
            <th class="text-left">Given</th>
            <th class="text-left">Initials</th>
            <th class="text-left">Note</th>
          </tr>
        </thead>
        <tbody v-if="parsedJournals.length > 0">
          <tr v-for="journal in parsedJournals" :key="journal.id" :class="rowClass(journal.marianatek_reservation_start_date)">
            <td>{{ formatDate(journal.marianatek_reservation_start_date) }} {{ formatTime(journal.marianatek_reservation_start_time) }}</td>
            <td>{{ journal.marianatek_reservation_class_name }}</td>
            <td>{{ journal.marianatek_customer_name }}</td>
            <td>{{ journal.payment_method }}</td>
            <td><v-simple-checkbox disabled :value="journal.is_redeemed"></v-simple-checkbox></td>
            <td>{{ journal.initials }}</td>
            <td>{{ journal.note }}</td>
          </tr>
        </tbody>
        <tbody v-if="parsedJournals.length === 0">
          <tr>
            <td colspan="7" class="text-center">No journals found for this date.</td>
          </tr>
        </tbody>
      </v-simple-table>

      <v-row v-if="isJournalsLoading">
        <v-col class="text-center">
          <v-progress-circular />
        </v-col>
      </v-row>

      <v-row>
        <v-col class="mt-4 text-center">
          <v-btn v-if="!ifShowPassed" text @click="showAllPassed">Show All Passed</v-btn>
          <v-btn v-if="ifShowPassed" text @click="hideAllPassed">Hide All Passed</v-btn>
        </v-col>
      </v-row>
      
    </v-sheet>

    <v-dialog persistent max-width="600" v-model="journalSubmitModal">
      <v-card class="pa-8">
        <v-card-title>
          <h3>{{ edit.marianatek_customer_name }}</h3>
        </v-card-title>
        <v-form>
          <v-text-field outlined v-model="edit.initials" label="Initials" />
          <v-textarea outlined v-model="edit.note" label="Note" />
          <v-checkbox label="Given journal" v-model="edit.is_redeemed"></v-checkbox>
          <v-row class="mt-3">
            <v-btn class="mr-4" large @click="closeEdit">Close</v-btn>
            <v-btn large color="primary" @click="save">Save</v-btn>
          </v-row>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { DateTime } from 'luxon';
import { orderBy } from 'lodash';

export default {
  name: 'CustomerJournalTable',
  data() {
    return {
      selectedLocation: null,
      showRedeemed: false,
      DateTime,
      selectedDate: this.now,
      ifShowPassed: false,
      edit: {},
      journalSubmitModal: false,
    }
  },
  watch: {
    showRedeemed() {
      this.getJournals()
    }
  },
  computed: {
    ...mapGetters({
      journals: 'customer-journal/list',
      locations: 'location/list',
    }),
    isJournalsLoading() {
      return this.$store.state['customer-journal'].isFindPending
    },
    parsedJournals() {
      let journals = this.journals

      journals = journals.map(journal => {
        return {
          ...journal,
          full_datetime: `${journal.marianatek_reservation_start_date}T${journal.marianatek_reservation_start_time}`,
        }
      })

      journals = orderBy(journals, 'full_datetime', 'asc')

      return journals
    },
    selectedDateJournals() {
      return this.parsedJournals.filter(journal => journal.marianatek_reservation_start_date === this.selectedDate)
    },
    startDate() {
      return DateTime.now().minus({ days: 3 }).toISODate()
    },
    endDate() {
      return DateTime.now().plus({ days: 3 }).toISODate()
    },
    now() {
      return DateTime.now().toISODate()
    },
    datesArray() {
      if (this.parsedJournals.length === 0) return []
      let dates = []
      let currentDate = DateTime.fromISO(this.startDate)

      while (currentDate.toISODate() <= this.endDate) {
        const currentDateJournals = this.parsedJournals.filter(journal => journal.marianatek_reservation_start_date === currentDate.toISODate());
        const total = currentDateJournals ? currentDateJournals.length : 0;
        const completed = currentDateJournals ? currentDateJournals.filter(journal => journal.is_redeemed).length : 0;

        dates.push({
          date: currentDate.toISODate(),
          total,
          completed
        })
        currentDate = currentDate.plus({ days: 1 })
      }

      return dates
    },
    isAdmin() {
      const email = this.$store.state.auth.payload.user.email
      return (email !== 'costamesa@rayoga.com' && email !== 'missionviejo@rayoga.com' && email !== 'longbeach@rayoga.com' && email !== 'newportbeach@rayoga.com')
    },
  },
  methods: {
    openEdit(item) {
      this.edit = item
      this.journalSubmitModal = true
    },
    closeEdit() {
      this.edit = {}
      this.journalSubmitModal = false
    },
    async save() {
      await this.$store.dispatch('customer-journal/patch', [this.edit.id,{
        is_redeemed: this.edit.is_redeemed,
        note: this.edit.note,
        initials: this.edit.initials
      }]);
      this.closeEdit()
    },
    showAllPassed() {
      this.ifShowPassed = true
    },
    hideAllPassed() {
      this.ifShowPassed = false
    },
    selectDate(date) {
      this.selectedDate = date
    },
    rowClass(date) {
      if (DateTime.fromISO(date).toISODate() === DateTime.local().toISODate()) return 'is-todays'
      if (DateTime.fromISO(date).toISODate() < DateTime.local().toISODate()) return 'is-passeds'
      return ''
    },
    isComplete(item) {
      return (item.initials !== '' && item.initials !== null && item.note !== '' && item.note !== null)
    },
    formatDate(date) {
      return DateTime.fromISO(date).toLocaleString(DateTime.DATE_MED)
    },
    formatTime(time) {
      return DateTime.fromISO(time).toLocaleString(DateTime.TIME_SIMPLE)
    },
    async getLocations() {
      this.$store.dispatch('location/find', {
        query: {
          $limit: 100
        }
      })
    },
    async getJournals() {
      let query = {
        $sort: { createdAt: -1 },
        $limit: 500
      }

      if (this.selectedLocation) {
        query.marianatek_reservation_location_name = this.selectedLocation
      }

      await this.$store.commit('customer-journal/clearAll', this.$store.state['customer-journal'])
      await this.$store.dispatch('customer-journal/find', {
        query
      })
    },
    async updateRedeemed(item, journal) {
      await this.$store.dispatch('customer-journal/patch', [journal.id,{
        is_redeemed: !journal.is_redeemed
      }]);
    }
  },
  async beforeMount() {
    await this.$store.commit('customer-journal/clearAll', this.$store.state['customer-journal'])

    if (this.$store.state.auth.payload.user.email === 'newportbeach@rayoga.com') this.selectedLocation = 'Newport Beach'
    if (this.$store.state.auth.payload.user.email === 'missionviejo@rayoga.com') this.selectedLocation = 'Mission Viejo'
    if (this.$store.state.auth.payload.user.email === 'longbeach@rayoga.com') this.selectedLocation = 'Long Beach'
    if (this.$store.state.auth.payload.user.email === 'costamesa@rayoga.com') this.selectedLocation = 'Costa Mesa'

    await this.getLocations()
    await this.getJournals()

    this.selectedDate = DateTime.now().toISODate()
  }
}
</script>

<style lang="scss">
.customer-journal-table {
  .location-name {
    font-weight: normal;
    margin-bottom: 10px;
    opacity: 0.3;

    &.active {
      font-weight: bold;
      opacity: 1;
    }
  }

  .date-select:hover {
    cursor: pointer;
    background-color: #898989;
  }

  tr.is-today {
    td {
      background-color: #497f49;
    }
  }
}
</style>